import {useRef, useState} from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import useOutsideClick from '../../../../hooks/useOutsideClick'
import {Dialog, Input} from '@mui/material'
import Gear from './Gear'
import {FilterHead, DialogMUI, FilterContainer} from './FiltersComponent.styles'

export const RAG_SPECIAL = 'SPECIAL'
export const RAG_SPECIAL_REVERT = 'SPECIAL_R'
const scaleElements = [{name: 'RAGAR'}, {name: 'RAG'}, {name: 'GAR'}, {name: RAG_SPECIAL}, {name: RAG_SPECIAL_REVERT}]

export const UnitElements = [
    {"name": "cells/μL"},
    {"name": "g/dL"}, {"name": "g/L"}, {"name": "%"}, {"name": "l/L"}, {"name": "tera/L"}, {"name": "x10^12/L"}, {"name": "giga/L"},
    {"name": "x10^9/L"}, {"name": "platelets/μL"},
    {
        "name": "mmol/L",
        isCog: true
    },
    {"name": "mg/dL"},
    {"name": "mEq/L"},
    {
        "name": "μmol/L",
        isCog: true
    },
    {"name": "mg/L"},
    {"name": "IU/L"}, 
    {"name": "mIU/L"}, 
    {"name": "mmHg"},
    {"name": "kPa"}, 
    {"name": "fl"}, {"name": "pg"}, {"name": "mm/h"}, {"name": "Ratio"}, {"name": "μg/L"}, {"name": "μg/g"}, {
        "name": "mmol/mol Hb",
        isCog: true
    },
    {"name": "nmol/(sL)"},
    {"name": "ml/min/1.73qm"}, {"name": "pmol/L", isCog: true}, {
        "name": "nmol/L",
        isCog: true
    }, {"name": "U/mL"}, {"name": "IU/mL"}, {"name": "ng/mL"}].map(it => {
        return {...it, _name: (it.name || '').toLowerCase()}
})

const FiltersComponent = ({
                              callback,
                              unitData,
                              scaleData,
                              filter,
                              indicator,
                              ages,
                              callbackAge
                          }: {
    filter: any
    unitData: any
    ages: any[]
    scaleData: any
    indicator: any
    callbackAge: (data: any) => void
    callback: (data: any) => void
}) => {
    const [isUnitOpen, setIsUnitOpen] = useState<any>(false)
    const [isScaleOpen, setIsScaleOpen] = useState<any>(false)
    const [ageOpen, setAgeOpen] = useState<any>(false)
    const [isModalOpen, setIsModalOpen] = useState<any>(false)
    const [newAge, setNewAge] = useState<any>({})


    const unitRef = useRef(null)
    const scaleRef = useRef(null)
    const ageRef = useRef(null)

    const handleCloseModal = () => setIsModalOpen(false)

    const handleSelect = (func: any, value: any) => {
        func(false)
        callback(value)
    }

    const handleOpen = (func: any) => {
        func((prev: any) => !prev)
    }

    const addInterval = () => {
        console.log('new inerval', newAge)
        // setNewAge(newAge);
        let age = {...newAge, id: new Date().getTime()};
        callbackAge([...ages, age]);
        handleCloseModal();
        handleSelect(setAgeOpen, {age})

    }

    const handleCloseAll = () => {
        setIsUnitOpen(false)
        setIsScaleOpen(false)
        setAgeOpen(false)
    }
    const onRemoveAge = (index: number) => {
        ages = ages.filter((it: any, ind: number) => ind != index)
        callbackAge([...ages]);
        // handleCloseModal();
        handleSelect(setAgeOpen, {age: null})
    }

    useOutsideClick([unitRef.current, scaleRef.current, ageRef.current], handleCloseAll)
    let unitEl = unitData?.name || filter.unitType.name;
    let unit = UnitElements.find((it: any) => it.name == unitEl) || UnitElements[0]
    console.log("BBM qqqqq biomarkers {{", unitData, filter, {unitEl, unit});

    let name = unitData?.name || filter.unitType.name;
    let isEditor = (global as any)?.isEditor;

    return (
        <div data-animch={10} data-rel>
            {/*<FilterHead style={{justifyContent: 'end'}}>*/}

            {/*    <p>Unit Type:</p>*/}
            {/*    <div ref={unitRef} onClick={() => handleOpen(setIsUnitOpen)}*/}
            {/*         style={{textAlign: 'left', zIndex: '1000'}}>*/}
            {/*        <span>{name}</span>*/}
            {/*        {isUnitOpen && (*/}
            {/*            <FilterContainer>*/}
            {/*                {UnitElements.map((unitType, index) => (*/}
            {/*                    <p*/}
            {/*                        className={'unitOpen'}*/}
            {/*                        key={index}*/}
            {/*                        onClick={(e) => {*/}
            {/*                            e.stopPropagation()*/}
            {/*                            handleSelect(setIsUnitOpen, {unitType})*/}
            {/*                        }}*/}
            {/*                    >*/}
            {/*                        {unitType.name}*/}
            {/*                    </p>*/}
            {/*                ))}*/}
            {/*            </FilterContainer>*/}
            {/*        )}*/}
            {/*        <KeyboardArrowDownIcon/>*/}
            {/*    </div>*/}
            {/*    {unit?.isCog && <Gear*/}
            {/*        value={indicator.multK}*/}
            {/*        onChange={(data: any) => {*/}
            {/*            console.log("qqqqq dataatata", data, name);*/}
            {/*            callback({unitType: {name}, ...data})*/}
            {/*        }}*/}
            {/*    ></Gear>}*/}

            {/*</FilterHead>*/}

            <FilterHead>
                <p>Scale Type:</p> {!isEditor && <div className={'textDisabled'}>{scaleData?.name || filter.scaleType.name}</div>}
                {isEditor && <div ref={scaleRef} onClick={() => handleOpen(setIsScaleOpen)}>
                    <span>{scaleData?.name || filter.scaleType.name}</span>
                    {isScaleOpen && (
                        <FilterContainer>
                            {scaleElements.map((scaleType, index) => (
                                <p
                                    className={'unitOpen'}
                                    key={index}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        handleSelect(setIsScaleOpen, {scaleType})
                                    }}
                                >
                                    {scaleType.name}
                                </p>
                            ))}
                        </FilterContainer>
                    )}
                    <KeyboardArrowDownIcon/>
                </div>}
            </FilterHead>
            <FilterHead>
                <p>Age Interval:</p>
                <div ref={ageRef} onClick={() => handleOpen(setAgeOpen)}>
                    {filter?.age && <><span>{filter.age.from} - {filter.age?.to}</span></>}
                    {!filter?.age && <><span>Default</span></>}

                    {ageOpen && (
                        <FilterContainer>
                            <p
                                className={'unitOpen'}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleSelect(setAgeOpen, {age: null})
                                }}
                            >
                                Default
                            </p>
                            {ages.map((age, index) => (
                                <p
                                    data-rel
                                    className={'unitOpen'}
                                    key={index}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        handleSelect(setAgeOpen, {age})
                                    }}
                                >
                                    {age.from} - {age.to}
                                    <span
                                        className={'closeUnit'}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onRemoveAge(index)
                                            return false;
                                        }}>
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                                        style={{width: '10px'}}
                                        focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon"
                                        data-hover="true">
                                        <path
                                            d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
                                </span>
                                </p>
                            ))}
                            {isEditor && <p
                                className={'unitOpen'}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setIsModalOpen(true)
                                }}
                                style={{color: '#3BAAB0', borderTop: '1px solid lightgrey'}}
                            >
                                Add Age Interval
                                {/*<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">*/}
                                {/*    <mask id="mask0_739_3788" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="2" y="2" width="14" height="14">*/}
                                {/*        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.625 2.8125C9.625 2.46732 9.34518 2.1875 9 2.1875C8.65482 2.1875 8.375 2.46732 8.375 2.8125V8.375H2.8125C2.46732 8.375 2.1875 8.65482 2.1875 9C2.1875 9.34518 2.46732 9.625 2.8125 9.625H8.375V15.1875C8.375 15.5327 8.65482 15.8125 9 15.8125C9.34518 15.8125 9.625 15.5327 9.625 15.1875V9.625H15.1875C15.5327 9.625 15.8125 9.34518 15.8125 9C15.8125 8.65482 15.5327 8.375 15.1875 8.375H9.625V2.8125Z" fill="#808080"/>*/}
                                {/*    </mask>*/}
                                {/*    <g mask="url(#mask0_739_3788)">*/}
                                {/*        <path d="M18 0H0V18H18V0Z" fill="#3BAAB0"/>*/}
                                {/*    </g>*/}
                                {/*</svg>*/}
                            </p>}

                        </FilterContainer>
                    )}
                    <KeyboardArrowDownIcon/>
                </div>
                <DialogMUI
                    style={{padding: '12px'}}
                    scroll='body'
                    aria-labelledby='scroll-dialog-title'
                    aria-describedby='scroll-dialog-description'
                    onClose={handleCloseModal}
                    open={isModalOpen}
                >

                    <div data-age-interval-desc>
                        Enter the age of the group "from" and "to":
                    </div>
                    <div style={{padding: '10px 0', display: 'inline-flex', gap: '12px', width: '100%'}}>

                        <div style={{width: '50%'}}>
                            <div>
                                <b>From</b>
                            </div>
                            <input value={newAge.from} placeholder={'From'} type={'number'} className={'w100'}
                                   style={{maxWidth: '100%'}}
                                   onChange={(e) => setNewAge({...newAge, from: e.target.value})}/>
                        </div>
                        <div style={{width: '50%'}}>
                            <div>
                                <b>To</b>
                            </div>
                            <input value={newAge.to} placeholder={'To'} type={'number'} className={'w100'}
                                   style={{maxWidth: '100%'}}
                                   onChange={(e) => setNewAge({...newAge, to: e.target.value})}/>
                        </div>
                    </div>
                    <div className={'tr'}>
                        <button className={'btn btn0'} onClick={handleCloseModal}>Cancel</button>
                        <button className={'btn'} onClick={addInterval}>Add Age Interval</button>
                    </div>


                </DialogMUI>
            </FilterHead>
        </div>
    )
}

export default FiltersComponent
